const fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function formatarBRL(valor: number | string | null | undefined): string {
  const n = typeof valor === 'string' ? Number(valor) : valor;
  if (n == null || Number.isNaN(n)) return '—';
  return fmt.format(n);
}

/** 30 vira "30%", e 33.33 vira "33,33%". */
export function formatarPercentual(percentual: number): string {
  return `${percentual.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
}

export function capitalize(valor: string | null | undefined): string {
  if (!valor) return '';
  return valor
    .toLowerCase()
    .split(' ')
    .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
    .join(' ');
}

/** Prazo do pagamento em linguagem de gente: minutos arredondados para cima a partir de 60 s, senão segundos. */
export function formatarTempoRestante(seg: number): string {
  if (seg >= 60) return `${Math.ceil(seg / 60)} min`;
  return seg === 1 ? '1 segundo' : `${seg} segundos`;
}

/** "Faltam 13 min para pagar"; o verbo concorda com 1 min / 1 segundo. */
export function textoFaltaParaPagar(seg: number): string {
  const tempo = formatarTempoRestante(seg);
  return `${tempo.startsWith('1 ') ? 'Falta' : 'Faltam'} ${tempo} para pagar`;
}

/** Normaliza para busca: minúsculas e sem acentos. */
export function normalizarTexto(valor: string): string {
  return valor
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export type FormatoData = 'hora' | 'data' | 'dataHora' | 'diaMesHora' | 'diaSemana'

const FORMATADORES_DATA: Record<FormatoData, Intl.DateTimeFormat> = {
  hora: new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  }),

  data: new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }),

  dataHora: new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }),

  diaMesHora: new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }),

  diaSemana: new Intl.DateTimeFormat('pt-BR', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit'
  }),
}

export function formatarData(valor: Date | string | number | null | undefined, formato: FormatoData = 'dataHora',): string {
  if (valor == null || valor === '') return '—'

  const data = valor instanceof Date ? valor : new Date(valor)
  if (Number.isNaN(data.getTime())) return '—'

  return FORMATADORES_DATA[formato].format(data)
}

/**
 * Máscara de CEP: mantém no máximo 8 dígitos e formata como `#####-###`.
 * Descarta qualquer caractere não numérico digitado/colado.
 */
export function formatarCep(valor: string): string {
  const digitos = valor.replace(/\D/g, '').slice(0, 8);
  return digitos.length > 5 ? `${digitos.slice(0, 5)}-${digitos.slice(5)}` : digitos;
}

export function formatarCpf(valor: string): string {
  const d = valor.replace(/\D/g, '').slice(0, 11)

  if (d.length <= 3) return d
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`

  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
}